import { useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '@/lib/auth/store';
import { BASE_PERMISSION } from '@/lib/constants/modules';
import { USER_ROLES } from '@/lib/constants/roles';
import { usePermission } from '@/lib/permissions/use-permission';
import { useCreateSmsWebhook } from '../api';
import { SmsWebhookForm, type SmsWebhookFormValues } from './SmsWebhookForm';

const initial: SmsWebhookFormValues = {
  webhookName: '',
  smsText: '',
  payload: '',
  apiBuilder: {
    url: '',
    method: 'GET',
    headers: [{ key: '', value: '' }],
    body: [{ key: '', value: '' }],
    rawHeaders: '',
    rawBody: '',
    headerMode: 'key-value',
    bodyMode: 'key-value',
  },
};

export function AddSmsWebhookPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.userId);
  const role = useAuthStore((s) => s.role);
  const isSubOrSuper = useAuthStore((s) => s.isSubOrSuperAdmin());
  const canAddAcl = usePermission('Manage Campaign.SMS Webhook List', BASE_PERMISSION.ADD);
  const canAdd = role !== USER_ROLES.S_ADMIN && canAddAcl;
  const create = useCreateSmsWebhook();

  // Super-admin still can't add SMS webhooks (unchanged); sub-super-admin
  // now needs the explicit ACL "add" permission on SMS Webhook List instead
  // of a blanket block.
  if (isSubOrSuper && !canAdd) return <Navigate to="/sms-webhook-list" replace />;

  return (
    <SmsWebhookForm
      mode="create"
      initialValues={initial}
      isPending={create.isPending}
      onSubmit={(payload) => {
        create.mutate(
          {
            ...payload,
            userId: Number(userId),
          },
          {
            onSuccess: (res) => {
              if (res?.message === 'Parameters Incorrect') {
                toast.error(res.message);
                return;
              }
              toast.success(res?.message ?? 'SMS webhook created');
              navigate('/sms-webhook-list');
            },
            onError: () => toast.error('Could not create the SMS webhook.'),
          },
        );
      }}
    />
  );
}
